import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Wallet from "./components/Wallet";
import { useState, useEffect } from "react";
import UseWindowDimensions from "./components/UseWindowDimensions";
import { isMobile, isTablet } from "react-device-detect";
import AV from "../src/av-package";
import GoToExperinceButton from "./components/GoToExperinceButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  let [state, setState] = useState({ showWalletModal: false });
  const [user, setUser] = useState(false);

  const [windowDimensionCondition, setWindowDimensionCondition] =
    useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    checkDemention();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const wallet_name = localStorage.getItem("wallet");

    if (wallet_name) {
      AV.isConnected(wallet_name).then(async (isConnected) => {
        console.log(isConnected);
        if (isConnected) setUser(true);
        else setUser(false);
      });
    }
  }, []);

  const checkDemention = () => {
    if (windowDimensions[0] <= 1280) {
      setWindowDimensionCondition(true);
    }
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return [width, height];
  }

  let handleModalVisibilty = (modalVisility) => {
    return () => {
      setState((state) => ({ ...state, showWalletModal: modalVisility }));
    };
  };

  const disconnectWalllet = () => {
    localStorage.removeItem("wallet");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(false);
  };

  return (
    <div className="App">
      <div className="pageHolder">
        {user && (
          <button
            className="btn btn-light md disconnect-wallet-btn"
            onClick={disconnectWalllet}
          >
            Disconnect Wallet
          </button>
        )}
        <a href="#" className="logo">
          <img src="/imgs/logo.svg" alt="virtua logo" />
        </a>
        <div className="content">
          <h1>WALLET ADDRESS</h1>
          <p>
            Enter your wallet address to check if you are eligible for the
            Cardano Island Crib Beta Launch
          </p>

          {user ? (
            <GoToExperinceButton />
          ) : (
            <button
              className=" btn btn-custom md"
              onClick={handleModalVisibilty(true)}
            >
              Connect Wallet
            </button>
          )}
        </div>
        <div className="copyright-txt">All Rights Reserved. Virtua 2022</div>
      </div>

      {windowDimensionCondition && (isMobile || isTablet) ? (
        <UseWindowDimensions
          windowDimensionConditionProp={windowDimensionCondition}
          setWindowDimensionCondition={setWindowDimensionCondition}
        />
      ) : (
        <Wallet
          open={state.showWalletModal}
          setOpen={handleModalVisibilty(false)}
          setUser={setUser}
        />
      )}

      <ToastContainer />
    </div>
  );
}

export default App;
